import React from "react";
import AppSelect from "../AppSelect/AppSelect";

/**
 * Choisit le niveau de détail d'un rapport.
 * @param {object} props
 * @param {string} [props.id]
 * @param {string} [props.value]
 * @param {(id: string, value: string) => void} [props.onValueChanged]
 * @param {boolean} [props.isDarkStyle]
 * @param {object} props.I18n
 * @param {(key: string) => string} props.I18n.get
 */
export default function ReportGranularitySelector(props) {
    const {
        id = "granularity",
        value = "Standard",
        onValueChanged,
        isDarkStyle = false,
        I18n
    } = props;

    return (
        <AppSelect
            id={id}
            label={I18n.get("Select granularity")}
            allowEmpty={false}
            defaultValue={value}
            onValueChanged={onValueChanged}
            isDarkStyle={isDarkStyle}
            options={[
                "Detailed",
                "Standard",
                "Consolidated"
            ]}
            I18n={I18n}
        />
    );
}
